import React from "react";
import "./Me.css";
import profilePic from "../../images/profile.jpg";

import { Button, Col, Container, Row } from "react-bootstrap";

const Me = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center me text-center container-fluid ">
      <Row className=" my-auto mt-lg-5">
        <Col className="my-auto" sm={12} md={6} lg={6}>
          <Container className="content animate__animated animate__fadeInLeft  ">
            <h3>Hi, I'm Md. Moshiur Rahman Akash</h3>
            <span>Front-End Developer</span>
            <p>
              I am a passionate JavaScript developer who is familiar with some
              frontend frameworks. I am comfortable to developed website with
              React.js, MongoDB, and Express.js
            </p>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://drive.google.com/file/d/1MWrFOZEgulzwV7a5oGdXexGa8-LAnNjx/view"
            >
              <Button variant="primary " className="font">
                Resume
              </Button>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/moshiur-rahman-akash/"
            >
              <Button variant="primary mx-2 " className="font">
                Hire me
              </Button>
            </a>
          </Container>
        </Col>
        <Col className="my-auto pro-image-container" sm={12} md={6} lg={6}>
          <Container className="profile-img pro-image  animate__animated animate__fadeInRight  ">
            <img className="image-fluid" src={profilePic} alt="my profile" />
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default Me;
